import React from 'react';
import ReactDOM from 'react-dom';
import App from './App'
import '../node_modules/bootstrap/dist/css/bootstrap.css';
import '../node_modules/jquery/dist/jquery'
import '../node_modules/popper.js/dist/popper'
import '../node_modules/bootstrap/dist/js/bootstrap';

ReactDOM.render(<App />, document.getElementById('root'));

